// GEMELO DE `app/src/lib/fechaLocal.ts`. La cabecera es lo único que puede
// diferir: el guard compara el código.
//
// [356] `esMenor` BAJA AQUÍ AUNQUE EL PANEL TODAVÍA NO LA LLAME, y se dice
// para que nadie la busque en uso: el gemelo del catálogo exige que los dos
// ficheros sean iguales, y lo que no puede divergir aquí no es un rótulo —es
// QUÉ DÍA ES HOY y, desde ahora, QUIÉN ES MENOR—. El día que el panel lo
// pregunte, la respuesta ya será la misma que da la app; y quien manda sobre
// las dos es `es_menor(birth_date, is_minor)` en la base (migs 351/355).
import { format } from 'date-fns';

// ============================================================
// EL DÍA DE CALENDARIO, EN LA ZONA DE QUIEN MIRA
// ============================================================
//
// `sessions.date`, `special_classes.date`, `gym_routines.date` y las de
// `formal_evaluations` son columnas `date` de Postgres: un día del calendario,
// SIN huso. Para hablar con ellas hace falta la fecha local, no un instante.
//
// `new Date().toISOString().split('T')[0]` da la fecha UTC, que es otra cosa.
// En España (CET/CEST, +1/+2) las dos coinciden 22 o 23 horas al día y difieren
// el resto, así que el fallo aparece de madrugada, no da error, no deja rastro y
// se arregla solo a las dos de la mañana. Ver §140.
//
// EL PATRÓN NO SE INVENTA: sale de `admin/src/pages/DashboardPage.tsx`, que ya
// había diagnosticado este bug exacto y lo dejó medido —«el lunes 28-sep salía
// como 2026-09-27»— con `format(d, 'yyyy-MM-dd')` de date-fns, que lee los
// componentes LOCALES. `date-fns` está en los dos package.json.
//
// ⚠️ Y HAY UNA VARIANTE PEOR, que es la razón de que `diaDe` exista y no solo
// `hoy`: `new Date(a, m, 1).toISOString().split('T')[0]`. Ahí la fecha se
// construye con componentes locales —medianoche local— y `toISOString` le resta
// el huso, así que da el día anterior LOS 365 DÍAS DEL AÑO, no de madrugada. El
// informe mensual del entrenador arrancaba el 31 del mes pasado, siempre.
//
// Lo que NO hace este módulo: instantes. Un `timestamptz` —`created_at`,
// `reviewed_at`, `expiry_date`— quiere un momento en el tiempo, y para eso
// `toISOString()` es lo correcto. Ver §140, familia 5.

/** El día de calendario de `d` en la zona del dispositivo. */
export function diaDe(d: Date): string {
  return format(d, 'yyyy-MM-dd');
}

/** Hoy, como día de calendario local. */
export function hoy(): string {
  return diaDe(new Date());
}

/**
 * ¿Consta que esta persona es MENOR de edad?
 *
 * ⚠️ QUIEN MANDA ES LA BASE. `es_menor(birth_date, is_minor)` (migs 351/355) es
 * la referencia, y cuenta los 18 años con **la fecha del club**; esto solo
 * decide qué se PINTA y qué viaje se evita. Si las dos discrepan, la que vale
 * es la de allí.
 *
 * Y afirma en POSITIVO: sin fecha no se dice que sea menor. El default cómodo
 * —tratar la ausencia como minoría— autorizaría un borrado irreversible sobre
 * una ficha de la que no se sabe la edad.
 *
 * [356] Vive aquí y no en el componente porque ya hay DOS sitios que lo
 * preguntan —el botón de baja del hijo y la confirmación de la baja del
 * tutor— y dos copias de «quién es menor» es exactamente lo que la 355 vino a
 * quitar en la base.
 */
export function esMenor(birthDate: string | null | undefined): boolean {
  if (!birthDate) return false;
  const dieciocho = new Date(hoy());
  dieciocho.setFullYear(dieciocho.getFullYear() - 18);
  return new Date(birthDate) > dieciocho;
}
